import React, { useState } from "react";
import Select from "react-select";

const WholesalerDropdown = ({ data, setSelectedRecord }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      zIndex: 9999999,
      borderColor: state.isFocused ? "#ccc" : "#ddd",
      boxShadow: state.isFocused ? "0 0 0 2px #f0f0f0" : "none",
      "&:hover": {
        borderColor: "#bbb",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      zIndex: 9999999,
      backgroundColor: state.isSelected
        ? "#f0f8ff"
        : state.isFocused
        ? "#e6f7ff"
        : "white",
      color: state.isSelected ? "#000" : "#333",
      "&:active": {
        backgroundColor: "#cce7ff",
      },
    }),
  };
  

  // Transform data for react-select options
  const options = data.map((saler) => ({
    value: saler?.id,
    label: saler?.name,
  }));

  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
    const record = data.find(
      (item) => item?.name?.trim()?.toLowerCase() === selected?.label?.trim()?.toLowerCase()
    );
    setSelectedRecord(record || null);
  };

  return (
    <div className="dropdownUI">
      <label htmlFor="chemist-dropdown" style={{ marginBottom: "8px", display: "block" }}>
        Select WholeSaler:
      </label>
      <Select
        styles={customStyles}
        id="chemist-dropdown"
        value={selectedOption}
        onChange={handleSelectChange}
        options={options}
        placeholder="-- Select WholeSaler --"
        className="allProductsTable__searchBox searchable_dropdown__filter"
        isSearchable
      />
    </div>
  );
};

export default WholesalerDropdown;
